<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">氏名・現住所</div>
  <div class="card-item-content">
    <div class="input-item">
      <label for="">氏名</label>
      <Input placeholder="氏名"
        v-model="item.data.name" />
    </div>
    <div class="input-item"
      v-if="item.data.gender">
      <label for="">性別</label>
      <RadioGroup v-model="item.data.gender.kind">
        <Radio label="male">{{ $planConfig.genderList.male }}</Radio>
        <Radio label="female">{{ $planConfig.genderList.female }}</Radio>
        <Radio label="custom">{{ $planConfig.genderList.custom }}</Radio>
      </RadioGroup>
      <Input v-show="item.data.gender.kind === 'custom'"
        v-model="item.data.gender.customText" />
    </div>
    <div class="input-item">
      <label for="">生年月日</label>
      <my-date v-bind:date="item.data.dateOfBirth" />
    </div>
    <div class="input-item">
      <label for="">郵便番号</label>
      <Input placeholder="1001000"
        v-model="item.data.address.postalCode" />
    </div>
    <div class="input-item">
      <label for="">住所</label>
      <Input placeholder="住所"
        v-model="item.data.address.postalDetail" />
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
